import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { DataContext } from "../DataLayer/Datalayer";
import CircleLoading from "../LoaingPage/CircleLoading";

import { Link } from "react-router-dom";

import "../AuthForm/AuthStyle.css";

function SignIn() {
  const { t } = useTranslation(["common"]);
  const context = useContext(DataContext);
  const pageLoading = context.pageLoading;
  const handleSignin = context.handleSignin;
  const isDark = context.isDark;

  return (
    <div className={`login ${isDark ? "login-dark" : "login-light"}`}>
      {isDark ? (
        <Link to="/">
          <img
            className="login__logo-dark"
            alt="#"
            src="https://www.nicepng.com/png/full/16-167642_amazon-logo-amazon-logo-white-text.png"
          />
        </Link>
      ) : (
        <Link to="/">
          <img
            className="login__logo-light"
            alt="#"
            src="https://help.pacisoft.com/wp-content/uploads/2017/11/amazon-logo-preview.png"
          />
        </Link>
      )}
      <div
        className={`login__container ${
          isDark ? "login__container-dark" : "login__container-light"
        }`}
      >
        <div className="login__containertop">
          <h2>{t("Sign-In")}</h2>
          <form className="login__form">
            <div className="signin__password">
              <h4>{t("Password")}</h4>
              <h4>
                <Link to={"/forgotpassword"}>
                  {t("Forgot your password ?")}
                </Link>
              </h4>
            </div>

            <input
              className="login__input"
              type="password"
              name="password"
              value={context.password}
              onChange={(e) => context.setPassword(e.target.value)}
            />
            <p className="login__errorMsg">{context.signInErrorMsg}</p>
            <div className="login__button">
              <button type="submit" onClick={handleSignin}>
                {pageLoading ? <CircleLoading /> : t("Sign-In")}
              </button>
            </div>

            <div className="login__text  login__checkbox ">
              <input type="checkbox" name="rememberMe" />
              <p>&nbsp;Keep me signed in. Details</p>
            </div>
          </form>
        </div>
        <ul className="login__ect">
          <li>{t("Conditions of Use")}</li>
          <li>{t("Privacy Notice")}</li>
          <li>{t("Help")}</li>
        </ul>
        <span>© 1996-2022, Amazon.com, Inc. or its affiliates</span>
      </div>
    </div>
  );
}

export default SignIn;
